
export function getNextMonthlyOccurrence(fromDate: Date = new Date()): Date {
    const date = new Date(fromDate);
    const year = date.getFullYear();
    const month = date.getMonth(); // zero based, 0 = January, ... 11 = December
    const day = date.getDate();

    // today is 1st day of month, return today
    if (day === 1) {
        return date;
    }

    // otherwise, return the 1st day of the next month
    return new Date(
        month === 11 ? year + 1 : year, // year
        month === 11 ? 0 : month + 1,   // next month
        1   // day
    );
}

export function getNextWeeklyOccurrence(fromDate: Date = new Date()): Date {
    const date = new Date(fromDate);
    const day = date.getDay(); // zero based - 0 = Sunday, 1 = Monday

    // today is Monday, return today
    if (day === 1) {
        return date;
    }

    // otherwise, return the next Monday
    const daysUntilNextMonday = (8 - day) % 7;
    const result = new Date(date);
    result.setDate(date.getDate() + daysUntilNextMonday);

    return result;
}
